export const createObservable = (value, accessListener) => {
    if (accessListener && typeof Proxy !== "undefined") {
        const handler = {
            get(target, prop) {
                accessListener(target[prop]);
                return target[prop];
            }
        };
        return new Proxy(value, handler);
    }
    return value;
};
